import React from 'react';
import { cn } from '@/utils/cn';

interface ProjectDetailTabsProps {
  activeTab: string;
  onTabChange: (tab: string) => void;
}

export function ProjectDetailTabs({ activeTab, onTabChange }: ProjectDetailTabsProps) {
  const tabs = [
    { id: 'overview', label: 'Tổng quan' },
    { id: 'tasks', label: 'Công việc' },
    { id: 'progress', label: 'Tiến độ' },
    { id: 'docs', label: 'Tài liệu' },
    { id: 'personnel', label: 'Nhân sự' },
    { id: 'equipment', label: 'Thiết bị' },
    { id: 'materials', label: 'Vật tư' },
    { id: 'costs', label: 'Chi phí' },
    { id: 'logs', label: 'Nhật ký hoạt động' },
    { id: 'history', label: 'Lịch sử' },
  ];

  return (
    <div className="flex items-center gap-1 border-b border-slate-100 overflow-x-auto scrollbar-none bg-white px-4">
      {tabs.map((tab) => (
        <button
          key={tab.id}
          onClick={() => onTabChange(tab.id)}
          className={cn(
            "relative px-4 py-4 text-xs lg:text-sm font-normal transition-all whitespace-nowrap",
            activeTab === tab.id
              ? "text-emerald-600 after:absolute after:bottom-0 after:left-0 after:h-0.5 after:w-full after:bg-emerald-600"
              : "text-slate-400 hover:text-slate-600"
          )}
        >
          {tab.label}
        </button>
      ))}
    </div>
  );
}
